<template>
    <nav class="text-white">
      <ul class="flex space-x-4 p-4">
        <li v-for="category in navigation.categories"
            :key="category.name"
            class="hoverable relative flex justify-center"
        >
            <a 
                :href="'/' + category.type"
                class="relative z-10 flex items-center justify-center text-sm font-medium text-white transition-colors duration-200 ease-out">
                {{ category.name }}
            </a>
            <div class="mega-menu pt-12 mb-16 sm:mb-0 shadow-xl">
                <div class="w-full bg-gray-900 p-6">
                    <div class="container mx-auto w-full flex flex-wrap justify-between mx-2">
                      <div class="w-full text-white mb-8">
                        <h2 class="font-bold text-2xl">{{ category.name }}</h2>
                        <p>Encuentra la claridad visual que necesitas con lentes diseñados para tu comodidad y estilo.</p>
                      </div>
                      <ul class="px-4 w-full sm:w-1/2 lg:w-1/4 border-gray-600 border-b sm:border-r lg:border-b-0 pb-6 pt-6 lg:pt-3">
                        <div class="flex items-center">
                          <svg class="h-8 mb-3 mr-3 fill-current text-white"
                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                            <path d="M3 6c0-1.1.9-2 2-2h8l4-4h2v16h-2l-4-4H5a2 2 0 0 1-2-2H1V6h2zm8 9v5H8l-1.67-5H5v-2h8v2h-2z"/>
                          </svg>
                          <h3 class="font-bold text-xl text-white text-bold mb-2">Categorias</h3>
                        </div>
                        <!-- <p class="text-gray-100 text-sm">aa.</p> -->
                        <router-link
                            v-for="item in category?.subcategories" :key="item.name"
                            :to="'/aaa'"
                            class="flex items-center text-sm font-medium text-white z-10"
                            >
                            {{ item.name }}
                        </router-link>
                        <div class="flex items-center py-3">
                            <svg class="h-6 pr-3 fill-current text-blue-300"
                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M20 10a10 10 0 1 1-20 0 10 10 0 0 1 20 0zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0zm-8 2H5V8h5V5l5 5-5 5v-3z"/>
                            </svg>
                            <a href="#" class="text-white bold border-b-2 border-blue-300 hover:text-blue-300">Find out more...</a>
                        </div>
                      </ul>
                      <ul class="px-4 w-full sm:w-1/2 lg:w-1/4 border-gray-600 border-b sm:border-r-0 lg:border-r lg:border-b-0 pb-6 pt-6 lg:pt-3">
                        <div class="flex items-center">
                          <svg class="h-8 mb-3 mr-3 fill-current text-white"
                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                            <path d="M4.13 12H4a2 2 0 1 0 1.8 1.11L7.86 10a2.03 2.03 0 0 0 .65-.07l1.55 1.55a2 2 0 1 0 3.72-.37L15.87 8H16a2 2 0 1 0-1.8-1.11L12.14 10a2.03 2.03 0 0 0-.65.07L9.93 8.52a2 2 0 1 0-3.72.37L4.13 12zM0 4c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4z"/>
                          </svg>
                          <h3 class="font-bold text-xl text-white text-bold mb-2">Formas</h3>
                        </div>
                        <!-- <p class="text-gray-100 text-sm">aa.</p> -->
                        <router-link
                            v-for="item in navigation.shapes" :key="item.name"
                            :to="'/aaa'"
                            class="flex items-center text-sm font-medium text-white z-10"
                            >
                            {{ item.name }}
                        </router-link>
                        <div class="flex items-center py-3">
                          <svg class="h-6 pr-3 fill-current text-blue-300"
                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                            <path d="M20 10a10 10 0 1 1-20 0 10 10 0 0 1 20 0zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0zm-8 2H5V8h5V5l5 5-5 5v-3z"/>
                          </svg>
                          <a href="#" class="text-white bold border-b-2 border-blue-300 hover:text-blue-300">Find out more...</a>
                        </div>
                      </ul>
                      <ul class="px-4 w-full sm:w-1/2 lg:w-1/2 pb-6 pt-6 lg:pt-3">
                        <div class="flex items-center">
                          <svg class="h-8 mb-3 mr-3 fill-current text-white"
                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                            <path d="M2 4v14h14v-6l2-2v10H0V2h10L8 4H2zm10.3-.3l4 4L8 16H4v-4l8.3-8.3zm1.4-1.4L16 0l4 4-2.3 2.3-4-4z"/>
                          </svg>
                          <h3 class="font-bold text-xl text-white text-bold mb-2">Marcas</h3>
                        </div>
                        <!-- <p class="text-gray-100 text-sm">aa.</p> -->
                        <router-link
                            v-for="item in navigation.brands" :key="item.name"
                            :to="'/aaa'"
                            class="flex items-center text-sm font-medium text-white z-10"
                            >
                            <img class="h-12" :src="apiUrl+'/'+item.logo" alt="">
                            {{ item.name }}
                        </router-link>
                        <div class="flex items-center py-3">
                          <svg class="h-6 pr-3 fill-current text-blue-300"
                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                            <path d="M20 10a10 10 0 1 1-20 0 10 10 0 0 1 20 0zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0zm-8 2H5V8h5V5l5 5-5 5v-3z"/>
                          </svg>
                          <a href="#" class="text-white bold border-b-2 border-blue-300 hover:text-blue-300">Find out more...</a>
                        </div>
                      </ul>
                    </div>
                </div>
            </div>
        </li>
        <router-link
          v-for="page in navigation.pages"
          :key="page.name"
          :to="page.href"
          class="flex items-center text-sm font-medium text-white z-10"
        >
          {{ page.name }}
        </router-link>
      </ul>
    </nav>
  </template>
  
  <script lang="ts">
  export default {
    name: "SuperMenu",
    props: {
      navigation: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        // Accedemos a la variable de entorno
        apiUrl: process.env.VUE_APP_API_BASE_URL || 'No se ha configurado la URL',
      };
    },
  };
  </script>
  
  <style scoped>
  .group-hover\:translate-y-0 {
    transform: translateY(0) !important;
  }
  
  .group:hover > div {
    left: 0 !important;
    width: 100vw !important; /* Asegura que cubra el 100% del ancho del viewport */
  }

  /* ––––––––––––––––––––––––––––––––––––––––––––––––––
    Based on: https://codepen.io/nickelse/pen/YGPJQG
    Influenced by: https://sproutsocial.com/
  –––––––––––––––––––––––––––––––––––––––––––––––––– */


  /* #Mega Menu Styles
  –––––––––––––––––––––––––––––––––––––––––––––––––– */
  .mega-menu {
    display: none;
    left: 0;
    position: absolute;
    text-align: left;
    width: 100%;
  }



  /* #hoverable Class Styles
  –––––––––––––––––––––––––––––––––––––––––––––––––– */
  .hoverable {
    position: static;
  }

  .hoverable:hover .mega-menu {
    display: block;
  }


  /* #toggle Class Styles
  –––––––––––––––––––––––––––––––––––––––––––––––––– */

  .toggleable > label:after {
    content: "\25BC";
    font-size: 10px;
    padding-left: 6px;
    position: relative;
    top: -1px;
  }

  .toggle-input {
    display: none;
  }
  .toggle-input:not(checked) ~ .mega-menu {
    display: none;
  }

  .toggle-input:checked ~ .mega-menu {
    display: block;
  }

  .toggle-input:checked + label {
    color: white;
    background: #2c5282; /*@apply bg-blue-800 */
  }

  .toggle-input:checked ~ label:after {
    content: "\25B2";
    font-size: 10px;
    padding-left: 6px;
    position: relative;
    top: -1px;
  }

  </style>
  